import { getMessages } from '../../../../../../../../store/constants';

export const MY_WORK_SETTINGS_SHOW_TITLE = getMessages().getText('assigned_to_me.settings.show.title');
export const MY_WORK_SETTINGS_SHOW_COLUMNS_TITLE_LABEL = getMessages().getText('assigned_to_me.settings.show.column_titles');
export const MY_WORK_SETTINGS_SHOW_EMPTY_GROUPS_LABEL = getMessages().getText('assigned_to_me.settings.show.empty_groups');
export const MY_WORK_SETTINGS_SHOW_ARCHIVED_CARDS_LABEL = getMessages().getText('assigned_to_me.settings.show.archived_cards');
